module.exports = __webpack_public_path__ + "img/interface2.509a14e6.png";